import { Updater } from 'widgets-for-react'

export const fieldUpdater =
  <State>() =>
  <Key extends keyof State>(key: Key) =>
  (updater: Updater<State[Key]>) =>
  (state: State): State => ({ ...state, [key]: updater(state[key]) })

export const fieldReplacer =
  <State>() =>
  <Key extends keyof State>(key: Key) =>
  (newValue: State[Key]) =>
    fieldUpdater<State>()(key)(() => newValue)

export const partialUpdater =
  <PartialState>(updater: Updater<PartialState>) =>
  <State extends PartialState>(state: State): State => ({ ...state, ...updater(state) })

export const partialReplacer = <PartialState>(newValue: PartialState) => partialUpdater(() => newValue)

export const arrayItemUpdater =
  <State>(index: number, updater: Updater<State>, elseUpdater?: Updater<State>) =>
  (array: Array<State>): Array<State> =>
    array.map((item, i): State => (i == index ? updater(item) : elseUpdater == undefined ? item : elseUpdater(item)))

export const arrayItemReplacer = <State>(index: number, newValue: State) =>
  arrayItemUpdater<State>(index, () => newValue)
